<div class="ticomix-search-container" [class.disabled]="disabled">
  <!-- Error message display -->
  <div class="error-message" *ngIf="errorMessage()" role="alert" aria-live="polite">
    {{ errorMessage() }}
  </div>
  
  <div class="input-group" role="search">
    <!-- AutoComplete Input -->
    <div class="autocomplete-container">
      <kendo-autocomplete #autoComplete 
        [data]="filteredItems()" 
        [valueField]="options.dataTextField!"
        [placeholder]="options.placeholder || ''" 
        [formControl]="searchControl" 
        [filterable]="true"
        [loading]="loading()" 
        [disabled]="disabled"
        [readonly]="readonly"
        (filterChange)="onFilterChange($event)" 
        (valueChange)="onValueChange($event)"
        (keypress)="onKeyPress($event)" 
        (focus)="onFocus()" 
        (blur)="onBlur()"
        [attr.aria-label]="options.ariaLabel || 'Search input'"
        [attr.aria-describedby]="'search-help-' + componentId"
        [attr.aria-busy]="loading()"
        [attr.aria-invalid]="errorMessage() ? 'true' : null"
        [attr.aria-errormessage]="errorMessage() ? 'error-message' : null">
      </kendo-autocomplete>
      <span class="sr-only" [id]="'search-help-' + componentId">
        Type to search. Press Enter to select. Use arrow keys to navigate suggestions.
      </span>
    </div>

    <!-- Button Group -->
    <span class="input-group-btn" role="group" [attr.aria-label]="'Search actions'">
      <!-- Search Button -->
      <button *ngIf="showSearchButton" 
        class="btn btn-primary" 
        type="button" 
        (click)="onSearchClick()"
        [disabled]="disabled"
        [attr.aria-label]="'Open advanced search window'"
        [attr.title]="'Open advanced search (Alt+S)'">
        <span class="fa fa-search" aria-hidden="true"></span>
      </button>

      <!-- Info Button (conditional) -->
      <button *ngIf="showInfoButton" 
        class="btn btn-primary" 
        type="button" 
        (click)="onInfoClick()"
        [attr.aria-label]="'View detailed information'"
        [attr.title]="'View details (Alt+I)'"
        [disabled]="disabled || !selectedItem()">
        <span class="fa fa-search-plus" aria-hidden="true"></span>
      </button>

      <!-- Goto Button (conditional) -->
      <button *ngIf="showGotoButton" 
        class="btn btn-primary" 
        type="button" 
        (click)="onGotoClick()"
        [attr.aria-label]="'Navigate to selected item'"
        [attr.title]="'Go to item (Alt+G)'"
        [disabled]="disabled || !selectedItem()">
        <span class="fas fa-share-square" aria-hidden="true"></span>
      </button>
    </span>
  </div>
</div>

<!-- Default Grid Window (used if no custom grid window is provided) -->
<ng-container *ngIf="!customGridWindow">
  <ticomix-grid-window #defaultGridWindow
    [title]="options.gridWindow?.title || 'Search'" [width]="options.gridWindow?.width || 800"
    [height]="options.gridWindow?.height || 600"
    [searchFields]="options.gridWindow?.searchFields || [{ fieldName: options.dataTextField, labelText: options.dataTextField }]"
    [dataSource]="options.dataSource"
    (rowSelect)="onRowSelect($event)">
  </ticomix-grid-window>
</ng-container>

<!-- Allow for content projection of a custom grid window if needed -->
<ng-content select="ticomix-grid-window"></ng-content>